<div class="d-flex justify-content-end align-items-center pt-3 position-relative">
  <!-- Hide the dropdown button, if the binding time is not visible since there's no available currently -->
  @if (bindingTimeVisible) {
    <i
      #showDropdownBtn
      class="fa-regular fa-ellipsis fa-lg dialogControlBtn cursorPointer mr-4"
      (click)="showMenuItems = true"
    ></i>
  }
  <i class="fa-regular fa-xmark fa-xl dialogControlBtn cursorPointer mr-3" (click)="close()"></i>

  @if (showMenuItems) {
    <div class="customDropdown" #dropdown>
      @if (displayedContent !== 'deviceInfo') {
        <div class="dropdownOption" (click)="toggle('deviceInfo')">
          {{ "DEVICE_INFORMATION" | translate}}
        </div>
      }
      @if (displayedContent !== 'bindTimeManager') {
        <div class="dropdownOption" (click)="toggle('bindTimeManager')">
          {{ "EDIT_BINDING_TIME" | translate}}
        </div>
      }
    </div>
  }
</div>

@if (successMsg) {
  <div class="alert alert-success" [@fadeOut] role="alert">
    {{ successMsg | translate }}
  </div>
}

@switch (displayedContent) {
  @case ('deviceInfo') {
    <app-device-information
      [device]="device">
    </app-device-information>
  }
  @case ('bindTimeManager') {
    <app-device-bind-time-manager
      [device]="device"
      (closed)="openDefaultTab($event)"
    ></app-device-bind-time-manager>
  }
}
